import { Box, Tooltip, Typography } from "@mui/material";
import { tableTextStyles } from "./cellUtils";

type Role = { title: string };

export type RoleCellProps = {
  roles?: Role[];
  align?: "left" | "center" | "right";
};

export function RoleCell({ roles, align = "left" }: RoleCellProps) {
  if (!roles?.length) {
    return <Typography sx={tableTextStyles}>—</Typography>;
  }

  const rolesText = roles.map((r) => r.title).join(", ");

  return (
    <Tooltip title={rolesText} placement="top">
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: align,
          height: "100%",
        }}
      >
        <Typography sx={tableTextStyles}>{rolesText}</Typography>
      </Box>
    </Tooltip>
  );
}
